import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function AdminPageHeader({ eyebrow, title, description, children, className }) {
  return (
    <div className={cn('mscm-admin-page-header', className)}>
      <div className="min-w-0">
        {eyebrow ? <p className="mscm-admin-eyebrow">{eyebrow}</p> : null}
        <h1 className="mscm-admin-title">{title}</h1>
        {description ? <p className="mscm-admin-description">{description}</p> : null}
      </div>
      {children ? <div className="mscm-admin-header-actions">{children}</div> : null}
    </div>
  );
}

export function AdminSurface({ className, children, ...props }) {
  return (
    <div className={cn('mscm-admin-surface', className)} {...props}>
      {children}
    </div>
  );
}

export function AdminEmptyState({ icon: Icon, title, description, action, className, testId }) {
  return (
    <div className={cn('mscm-admin-empty-state', className)} data-testid={testId}>
      {Icon ? (
        <div className="mscm-admin-empty-icon" aria-hidden="true">
          <Icon size={26} />
        </div>
      ) : null}
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}

export function AdminLoadingState({ label = 'Loading content' }) {
  return (
    <div className="mscm-admin-loading" role="status" aria-live="polite">
      <Loader2 size={22} className="animate-spin text-[#2D5BE3]" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
